module.exports = __webpack_public_path__ + "baa7a80d862638329df9f570a72899c1.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/golf-channel.svg
 ** module id = 433
 ** module chunks = 0
 **/